module.exports = __webpack_public_path__ + "img/156.5b2224ec.png";